<div class="bg-white h-screen flex justify-center items-center lg:hidden">
  <h1 class="text-2xl">You cannot access calendar view in this resolution</h1>
</div>

<div class="bg-white hidden relative lg:block">
  <div
    *ngIf="isLoading"
    class="bg-gray-100 absolute w-full h-full opacity-40 z-[10]"
  ></div>
  <div class="tix-full-calendar">
    <full-calendar #calendar [options]="calendarOptions">
      <ng-template #eventContent let-arg>
        <!--
                <div
          class="z-[100] absolute top-0 left-0 h-full max-h-[11rem] w-full bg-gradient-to-b from-white via-black to-black opacity-60"
        ></div>

        -->

        <tix-event-front-calendar-card
          [calendarLastDay]="calendarViewLastDate"
          [event]="arg.event"
        ></tix-event-front-calendar-card>
      </ng-template>
    </full-calendar>
  </div>
</div>
